import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { useThemeMode } from '../../../../../_metronic/partials';
import { DepartmentWiseChartProps } from '../../core/_models';

export const AnalyticsBarColumnChart = ({ dataActivity }: { dataActivity: DepartmentWiseChartProps }) => {
  const { mode } = useThemeMode();

  const options: ApexOptions = {
    series: [
      {
        name: 'Edited',
        data: dataActivity.map((item) => item.activities.EDITED),
      },
      {
        name: 'Shared',
        data: dataActivity.map((item) => item.activities.SHARED),
      },
      {
        name: 'Renamed',
        data: dataActivity.map((item) => item.activities.RENAMED),
      },
    ],
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false, // Disable the toolbar/menu
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 4, // Adjust this for rounded edges
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: dataActivity.map((item) => item.date),
      labels: {
        style: {
          colors: mode === 'dark' ? '#ffffff' : '#000000', // Change X-axis labels color based on theme
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      title: {
        text: '',
      },
      labels: {
        style: {
          colors: mode === 'dark' ? '#ffffff' : '#000000', // Change Y-axis labels color based on theme
          fontSize: '12px',
        },
        formatter: function (val) {
          return val.toString()
        },
      },
    },
    grid: {
      show: true,
      borderColor: mode === 'dark' ? '#565674' : '#DBDFE9',
      strokeDashArray: 0,
      position: 'back',
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          // Convert values to MB or GB for tooltip
         return val.toString()
        },
      },
    },
    legend: {
      show: false, // Disable the legend to remove series names from the bottom
    },
    colors: ['#4776E6', '#0D216D', '#1442B0'], // Custom colors for each series
  };

  return (
    <div id="chart" className="px-5">
      <Chart options={options} series={options.series} type="bar" height={312} />
    </div>
  );
};
